import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>© 2025 ANTI-STYLE HYPOTHESIS.</p>
      </div>
    </footer>
  );
};

export default Footer;
